import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const createBannerAction = createAsyncThunk(
    'create-banner',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.post(`/admins/api/create-banner`, { ...data })
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const createBannerSlice = createSlice({
    name: 'create-banner',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(createBannerAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(createBannerAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(createBannerAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const createBannerReducer = createBannerSlice.reducer